import { mapGetters, mapActions } from "vuex";
import { store } from "@sim/store/store";
import api from "@sim/services/api";
import router from "@sim/router";
import localStorage from "@sim/services/storage";
import SingleStep from "@sim/components/Partials/SingleStep.vue";
import StepWrapper from "@sim/components/Partials/StepWrapper.vue";
import IntlPhone from "@checkout/components/Partials/IntlPhone.vue";
import stepsMixin from "@sim/mixins/stepsMixin";
import _ from "lodash";
import moment from "moment";
import { transformErrors } from '@checkout/services/errors';

export default {
  name: "SimStep3",

  mixins: [stepsMixin],

  components: {
    SingleStep,
    StepWrapper,
    IntlPhone
  },

  data() {
    return {
      birthdayDateLimit: moment().subtract(18, 'years').format('YYYY-MM-DD'),
      form: {
        salutation: "",
        first_name: "",
        last_name: "",
        day: "",
        month: "",
        year: "",
        email: "",
        password: "",
        username: "",
        postal_code: "",
        mobilePhone: "",
      },
      errors: {},
      salutationOverwrite: false,
      prefix: localStorage.get('locale', true) ? '/'+localStorage.get('locale', true) : '/de',
    };
  },

  computed: {
    ...mapGetters(["steps"]),

    isDisabledFromEdit() {
      return this.form.hasOwnProperty('token');
    },
  },

  methods: {
    proceedToNextStep() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      api
        .post("/public-api/validate-sim-customer", this.form)
        .then((response) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          router.push(this.prefix+'/sim-registration/4');
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          if (error.response.status === 422) {
            this.errors = transformErrors(error.response.data.errors);
          }

          if (error.response.data.hasOwnProperty("username")) {
            var alertContent = document.createElement('span');
            alertContent.innerHTML=this.$i18nApi.t("userExists");
            this.$swal({
              content: alertContent,
              icon: "warning",
            });
          }

          if (error.response.data.hasOwnProperty("error")) {
            this.$swal(this.$i18nApi.t("messages.error"));
          } else if (error.response.status === 400) {
            this.$swal(error.response.data.message);
          }
        });
    },

    prepareStep3() {
      api
        .get("/public-api/prepare-sim/3/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form = response.data.user;

          if (this.form.salutation.length === 0) {
            this.salutationOverwrite = true;
          }

          let token = localStorage.get("token", true);

          if (token !== null) {
            this.form.token = token;
          }
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          router.push(this.prefix+"/sim-registration/1");
        });
    },

    getBirthday() {
      if (this.form.year && this.form.month && this.form.day) {
        return `${this.form.year}-${this.form.month}-${this.form.day}`;
      }

      return "";
    },

    updateBirthday(event) {
      const date = moment(event.target.value);
      const dateLimit = moment(this.birthdayDateLimit);

      if (date > dateLimit) {
        this.form.year = '';
        this.form.month = '';
        this.form.day = '';        
      } else {
        this.form.year = date.format('YYYY');
        this.form.month = date.format('MM');
        this.form.day = date.format('DD');
      }
    },
  },

  mounted() {
    this.prepareStep3();
  }
};
